import {Record} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import Image, {type Image as ImageRecord} from 'web-app/react/entities/common/image';

class Organization extends Record<{
    organizationId: string;
    title: string;
}>({
    organizationId: '',
    title: '',
}) {}

type Statistics = {
    total: number;
    checkedId: number;
    status: {
        SICK: number;
        CHILD_SICK: number;
        VACATION: number;
        ABSENT: number;
        ON_BUS: number;
        ON_TRIP: number;
        IN_MEETING: number;
    };
};

export class InstitutionPreview extends Record<{
    institutionId: string;
    organizationId?: string;
    organization?: Organization;
    behaviors: BehaviorsCollection;
    image: ImageRecord | null;
    title?: string;
    stats: {children: Statistics; employees: Statistics} | null;
}>({
    institutionId: '',
    organizationId: undefined,
    organization: undefined,
    behaviors: new BehaviorsCollection([]),
    image: null,
    title: undefined,
    stats: null,
}) {}

function fromAPI(data: any) {
    const {behaviors, organization, image, ...otherData} = data;

    const thisOrganization = organization ? new Organization(organization) : undefined;

    return new InstitutionPreview({
        behaviors: new BehaviorsCollection(behaviors),
        organization: thisOrganization,
        image: Image.fromAPI(image),
        ...otherData,
    });
}

export default {
    record: InstitutionPreview,
    default: new InstitutionPreview(),
    fromAPI,
};
